import { CircularProgress } from '@material-ui/core';

import { useAppSelector } from '../../App/redux/store';
import { getModalsState } from '../../features/modals/modalsSlice';
import { getLoaderState } from '../../store/loader/reducer';
import './styles/Loader.scss';

function Loader() {
  const isLoading = useAppSelector(getLoaderState);
  const { isLateralOpen } = useAppSelector(getModalsState);

  return isLoading ? (
    <div className={isLateralOpen ? 'loader-modal' : 'loader-container'}>
      <CircularProgress size={200} className="loader" />
    </div>
  ) : null;
}

export default Loader;
